import { render, staticRenderFns } from "./SelectedUnione.vue?vue&type=template&id=6fcb6cab&"
import script from "./SelectedUnione.vue?vue&type=script&lang=ts&"
export * from "./SelectedUnione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports